import { getCompany } from '@/api'
import { nanoid } from 'nanoid'
import { useSWRImmutable } from '@attensi/swr'

const uniqueKey = nanoid()

export const useCompany = () => {
  const { data } = useSWRImmutable([uniqueKey], getCompany)

  return {
    company: data,
  }
}
